import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Form, Input, Button, Spin } from "antd";
import { LoadingOutlined, LockOutlined, UserOutlined } from "@ant-design/icons";

import { callLogin } from "../../../services/authService";
import { GENERAL, NAME_VARIABLES, BUTTONS } from "../../../constants/AppConstants";

import "./FormLogin.css";

export default function FormLogin() {
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState("");
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    setLoginError("");

    const response = await callLogin(values);
    if (response?.status === 200) {
      setLoading(false);
      navigate("/v1/admin/dashboard");
    } else {
      const defaultError = "No pudimos iniciar sesion. Verifica tus credenciales e intenta de nuevo.";
      setLoginError(response?.data?.message || defaultError);
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="form-login">
      <div className="form-login__container">
        <div>
          <h1 className="form-login-title">{GENERAL.PAGE_NAME}</h1>
        </div>
        <div>
          <Form
            name="basic"
            className="form-login__container-form"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            {loginError && (
              <Form.Item>
                <Alert type="error" showIcon message={loginError} />
              </Form.Item>
            )}

            <Form.Item
              label={NAME_VARIABLES.USERNAME}
              name="username"
              rules={[
                { required: true, message: "Porfavor agrega tu email!" },
                {
                  type: "email",
                  message: "El email introducido no es válido",
                },
              ]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder={NAME_VARIABLES.USERNAME}
              />
            </Form.Item>

            <Form.Item
              label={NAME_VARIABLES.PASSWORD}
              name="password"
              rules={[
                { required: true, message: "Porfavor agrega tu contraseña!" },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder={NAME_VARIABLES.PASSWORD}
              />
            </Form.Item>

            <Form.Item className="form-login-button">
              <Spin spinning={loading} indicator={<LoadingOutlined spin />}>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={loading}
                  className="form-login-button-item"
                >
                  {BUTTONS.BUTTON_LOGIN}
                </Button>
              </Spin>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}
